"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportTokenUsage = void 0;
const functions_1 = require("firebase/functions");
/**
 * トークン使用量を報告するユーティリティ関数
 *
 * @param model モデル名
 * @param inputTokens 入力トークン数
 * @param outputTokens 出力トークン数
 * @param projectId プロジェクトID
 */
const reportTokenUsage = (model, inputTokens, outputTokens, projectId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const functions = (0, functions_1.getFunctions)(undefined, "asia-northeast1");
        const reportTokenUsageCall = (0, functions_1.httpsCallable)(functions, "reportTokenUsageEndpoint");
        yield reportTokenUsageCall({
            model,
            input_tokens: inputTokens,
            output_tokens: outputTokens,
            projectId,
        });
    }
    catch (error) {
        console.error("トークン使用量の報告に失敗しました", error);
    }
});
exports.reportTokenUsage = reportTokenUsage;
